(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1164],{

/***/ 79718:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/job-offers/[id]/preview/[previewId]",
      function () {
        return __webpack_require__(45145);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 45145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ OfferView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var components_jobOffer_JobOfferComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10306);
/* harmony import */ var components_jobOffer_JobOfferPageHead__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94125);
/* harmony import */ var context_wip_features_wip_features_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84245);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93642);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var utils_app_urls__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62177);






var __N_SSP = true;
function OfferView(param) {
    var offer = param.offer, origin = param.origin;
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_jobOffer_JobOfferPageHead__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                preview: true,
                url: utils_app_urls__WEBPACK_IMPORTED_MODULE_5__/* .APP_URLS.jobOffer */ .uu.jobOffer,
                offer: offer,
                locale: router.locale,
                origin: origin
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(context_wip_features_wip_features_context__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Provider */ .Z.Provider, {
                value: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_jobOffer_JobOfferComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    offer: offer,
                    origin: origin
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,6129,3467,6577,411,625,4882,1391,9774,2888,179], function() { return __webpack_exec__(79718); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);